"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const masters = [{
  name: "Jonathan Sterling",
  position: "Senior Mortgage Advisor",
  bio: "With over 20 years in financial services, Jonathan specializes in complex lending structures and high-net-worth portfolio management.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686228/img/advisor_jonathan_sterling.png",
  experienceYears: 20,
  progress: 98
}, {
  name: "Sarah Golding",
  position: "First-Time Buyer Specialist",
  bio: "Sarah is dedicated to guiding new homeowners through the lending process with clarity, patience, and expert market insight.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686228/img/specialist_sarah_golding.png",
  experienceYears: 12,
  progress: 92
}];
export default function MeetTheExperts() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="265030" id="meet-the-experts" className="bg-background text-foreground py-24 px-6 md:px-12 overflow-hidden" ref={ref}>
      <div className={`max-w-5xl mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 space-y-4">
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-primary">
            Meet the Experts
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            Our seasoned professionals bring decades of financial expertise to ensure your path to homeownership is seamless and secure.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {masters.map((master, i) => <Card key={master.name} data-index={i} className="group overflow-hidden border-border/40 shadow-xl bg-card flex flex-col h-full transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 rounded-md">
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={master.image} data-wvc-srcset={`${master.image}-wvc-srcset`} data-wvc-sizes={`${master.image}-wvc-sizes`} alt={master.name} loading="lazy" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out scale-105 group-hover:scale-100" />
                <div className="absolute bottom-0 left-0 right-0 bg-primary/90 p-5 backdrop-blur-md border-t border-secondary/30 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <h3 className="font-default text-2xl font-bold text-primary-foreground mb-1">
                    {master.name}
                  </h3>
                  <p className="text-secondary text-sm font-semibold uppercase tracking-widest">
                    {master.position}
                  </p>
                </div>
              </div>
              
              <CardContent className="p-6 flex flex-col flex-grow justify-between bg-card">
                <p className="text-muted-foreground text-sm leading-relaxed mb-8 font-default">
                  {master.bio}
                </p>
                
                <div className="space-y-3 mt-auto">
                  <div className="flex justify-between items-end text-xs font-bold text-foreground">
                    <span className="uppercase tracking-widest text-muted-foreground font-default">Industry Tenure</span>
                    <span className="text-secondary">{master.experienceYears} Years</span>
                  </div>
                  <Progress value={master.progress} className="h-1.5 bg-muted" />
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}